<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold py-3">لیست کلی عملکرد فروشندگان</h5>
                <div style="flex: 1"></div>
                <Back :url="`/admin/sales-management/reports/result-goods?start_date=${this.$route.query.start_date}&end_date=${this.filterDate.endDate}`" />
            </div>
            <div class="row px-4 not-in-print">
                <form autocomplete="new-password" @submit.prevent="doFilter"
                    class="col-12 d-flex justify-content-center align-items-center">

                    <div class="me-2">
                        <DatePickerRange v-model="filterDate" />
                    </div>

                    <button :disabled="disabled" type="submit" class="btn btn-info mr-5">
                        اعمال فیلتر
                    </button>

                </form>
            </div>
            <div class="d-flex my-4 mr-2-print px-5">
                <span class="ml-1 font-bold">گزارش کلی عملکرد فروشندگان</span>
                <div v-if="filterDate.startDate">
                    <span>از</span>
                    <span class="font-weight-bold mx-1">تاریخ</span><span> {{ filterDate.startDate | persianDate }}
                    </span>
                </div>
                <div class="mr-2" v-if="filterDate.endDate">
                    <span>تا</span>
                    <span class="font-weight-bold mx-1">تاریخ</span><span> {{ filterDate.endDate | persianDate }}
                    </span>
                </div>
            </div>
            <div class="row justify-content-center mb-3 g-3">
                <Loading class="mb-5" v-if="loading" />
                <div v-else-if="reports && reports.length" v-for="seller in reports" class="col-12 col-md-auto">
                    <router-link 
                    :to="`/admin/sales-management/reports/result-goods-sellers/${seller.id}?seller_name=${seller.full_name}&start_date=${filterDate.startDate}&end_date=${filterDate.endDate}`">
                        <div class="report-item-card">

                            <div class="seller-name">
                                {{ seller.full_name }}
                            </div>

                            <div class="seller-stats">
                                <div>ارسال شده: {{ seller.sent_count }}</div>
                                <div>فروخته شده: {{ seller.sold_count }}</div>
                                <div>برگشت داده شده: {{ seller.returned_count }}</div>
                                <div>نامشخص: {{ seller.unknown_count }}</div>
                                <div>بررسی شده: {{ seller.checked_count }}</div>
                            </div>

                        </div>
                    </router-link>
                </div>
                <p v-else>داده‌ای یافت نشد.</p>
            </div>
        </div>
    </main>
</template>

<script>
import { BTooltip, BFormGroup, BFormInput, BFormCheckbox, BTd, VBToggle, VBTooltip } from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import mixins from '@@/core/mixins/mixins'
import Loading from '@@/core/components/shared/Loading/Loading'
import Back from "@@/core/components/shared/Back/Back";

function Filter() {
    this.date = {
        startDate: "",
        endDate: "",
    };
}

Filter.prototype.set = function (filters) {
    Object.entries(filters).forEach(([index, value]) => {
        this[index] = value;
    });
};

export default {
    name: "ResultGoodsSellers",
    mixins: [mixins],
    components: {
        DatePickerRange,
        Loading,
        BFormCheckbox,
        BFormGroup,
        BTooltip,
        Back,
        BTd,
        BFormInput,
    },
    directives: {
        'b-toggle': VBToggle, 'b-tooltip': VBTooltip,
    },
    data() {
        return {
            disabled: true,
            search: "",
            to_id: "",
            from_id: "",
            loading: false,
            reports: null,
            filterDate: {
                endDate: "",
                startDate: "",
            },
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        print() {
            window.print();
        },
        doFilter() {
            this.reports = null;
            this.disabled = true;
            this.$route.query.start_date = null;
            this.$route.query.end_date = null;
            this.loadData();
        },
        async loadData() {
            this.loading = true;
            this.reports = null;
            
            if(this.$route.query.start_date && this.$route.query.end_date){
                this.filterDate.startDate = this.$route.query.start_date;
                this.filterDate.endDate = this.$route.query.end_date;
            }else{
                const today = new Date();
                const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                
                if (!this.filterDate.startDate || !this.filterDate.endDate) {
                    this.filterDate.startDate = this.formatDate(startOfToday);
                    this.filterDate.endDate = this.formatDate(today);
                }
            }

            try {
                const response = await this.$axios.get("admin/sellers-transaction-reports/list-by-sellers", {
                    params: {
                        start_date: this.filterDate.startDate,
                        end_date: this.filterDate.endDate,
                    },
                });

                this.reports = response.data.data.sellers;
                this.disabled = false;
            } catch (e) {
                this.reports = [];
            }

            this.loading = false;
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }

    },
    computed: {
    },
};
</script>

<style scoped>
.report-item-card {
    position: relative;
    overflow: hidden;
    width: 300px;
    max-width: 100%;
    padding: 21px 18px;
    border-radius: 16px;
    background: linear-gradient(0deg, #916a37a2, #acbed5da);
    border: 1px solid #e5e9f0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    transition: 0.5s ease;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
}

.report-item-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(110deg, #d7d07f8f, #acbed596);
    transform: translateX(100%);
    transition: transform 0.45s ease;
    z-index: 0;
}

.report-item-card:hover::before {
    transform: translateX(0);
}

.report-item-card * {
    position: relative;
    z-index: 1;
}

.seller-name {
    font-weight: 700;
    font-size: 17px;
    margin-bottom: 5px;
    display: flex;
    justify-content: center;
}

.seller-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 20px;
    width: 100%;
    position: relative;
}

.seller-stats::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 1px;
    background: #d0d0d0;
    transform: translateX(-50%);
}

.seller-stats div {
    font-weight: 600;
    font-size: 14px;
    color: #2b2b2b;
}
</style>
<style>
.print-only {
    display: none;
}

@media print {
    .not-in-print {
        display: none !important;
    }

    .app-content .side-app {
        padding: 0 !important;
    }

    body * {
        visibility: hidden;
    }

    .print-only {
        display: flex;
        justify-content: center;
    }

    #print,
    #print * {
        visibility: visible;
        font-size: 1.25rem;
    }

    #print {
        padding: 0 !important;
        width: 100%;
    }

    .mr-2-print {
        margin-right: 20px;
    }
}
</style>